type UserNameFields = {
  username: string;
  first_name?: string | null;
  last_name?: string | null;
};

export function getUserDisplayName(user: UserNameFields): string {
  const parts = [user.first_name?.trim(), user.last_name?.trim()].filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : user.username;
}

export function buildUserDisplayNameById<T extends UserNameFields & { id?: number }>(
  users: T[]
): Record<number, string> {
  return Object.fromEntries(
    users
      .filter((user) => user.id != null)
      .map((user) => [user.id, getUserDisplayName(user)])
  );
}

export function getUserInitials(user: UserNameFields): string {
  const first = user.first_name?.trim();
  const last = user.last_name?.trim();
  if (first && last) return (first[0] + last[0]).toUpperCase();
  if (first) return first.slice(0, 2).toUpperCase();
  if (last) return last.slice(0, 2).toUpperCase();
  return user.username.slice(0, 2).toUpperCase();
}
